import { render, staticRenderFns } from "./ComexForm.vue?vue&type=template&id=5bf3c26a&"
import script from "./ComexForm.vue?vue&type=script&lang=js&"
export * from "./ComexForm.vue?vue&type=script&lang=js&"
import style0 from "./ComexForm.vue?vue&type=style&index=0&id=5bf3c26a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports